import { Component, OnInit, ViewChild, ElementRef, Injectable } from "@angular/core";
import { ServerService } from "../../shared/services/server.service";
import { IRegion, SingleNews } from "../../shared/models/models";
import { UserInfo } from "../../components/header/header.component";
import { EventService } from '../../shared/services/event.service';
import * as  moment from 'moment';
import { environment } from '../../../environments/environment';

export interface INews {
  id?: number;
  title: string;
  newsText: string;
  regionListArray: number[];
  regionList?: string;
  file: any;
}


@Injectable()
@Component({
  selector: "app-page-news",
  templateUrl: "./page-news.component.html",
  styleUrls: ["./page-news.component.scss"]
})
export class PageNewsComponent implements OnInit {
  @ViewChild("fileInput", { static: false })
  fileInput: ElementRef;

  newNews: INews = {
    id: 0,
    title: null,
    newsText: null,
    regionListArray: [],
    regionList: "",
    file: null
  };

  regions: IRegion[] = [];
  news: INews[] = [];
  user: UserInfo = null;
  articles: SingleNews[] = [];

  loader: boolean = false;
  portalId: number = 1;

  constructor(private server: ServerService,
              private event: EventService) { }

  ngOnInit() {
    let user = localStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
      if (
        this.user.roles.some(e => e === "MioUser") &&
        this.user.roles.some(e => e === "BDAdmin")
      ) {
      }
      if (
        this.user.roles.some(e => e === "MioUser") &&
        this.user.roles.some(e => e !== "BDAdmin")
      ) {
        this.portalId = 1;
      }
      if (
        this.user.roles.some(e => e !== "MioUser") &&
        this.user.roles.some(e => e === "BDAdmin")
      ) {
      }
    }
    if (user) {
      this.user = JSON.parse(user);
      if (!this.user.roles.some(e => e === "MioRegionAdministrator"))
       {
        this.server.getNews(this.user.region[0].id).then(res => {
          res.map(r => {
            r.isOpen = false;
          });
          this.articles = this.updateArticles(res);
          this.getCountNews();
        });
      } else {
        this.server.getRegions().then(res => {
          this.regions = res;
        });
      }
    }

  }

  updateArticles(data: SingleNews[]) {
    let res = data.sort(function(a, b) {
      return moment.utc(b.updatedOn).diff(moment.utc(a.updatedOn));
    });
    return res;
  }

  notificationIsShow: boolean = false;
  addNews() {
    this.newNews.regionList = this.newNews.regionListArray.join("|");
    if (!this.newNews.title) {
      alert('Заполните поле "Заголовок"');
      return false;
    }
    if (!this.newNews.newsText) {
      alert('Заполните поле "Текст"');
      return false;
    }
    if (!this.newNews.regionList.length) {
      alert("Выберите регион");
      return false;
    }

    let newsFile = this.newNews.file === null ? '' : this.newNews.file;

    this.loader = true;

    this.server.setNews(this.newNews.title, this.newNews.newsText, this.newNews.regionList, newsFile).then(res => {
      if (res) {
        this.errorMessage = '';
        this.loader = false;
        this.notificationIsShow = true;
        setTimeout(() => {
          this.notificationIsShow = false;
        }, 3000);
        this.newNews = {
          id: 0,
          title: null,
          newsText: null,
          regionListArray: [],
          regionList: '',
          file: null
        };
        this.fileInput.nativeElement.value = '';
      }
    }, (err: any) => {
      if(err) {

        this.loader = false;
        this.errorMessage = err.error.message;
      }
    });
  }

  errorMessage: string = '';

  toggleRegion(region: IRegion) {
    let index = this.newNews.regionListArray.indexOf(region.id);
    if (index != -1) {
      this.newNews.regionListArray.splice(index, 1);
    } else {
      this.newNews.regionListArray.push(region.id);
    }
  }

  getRegionClass(region: IRegion) {
    let index = this.newNews.regionListArray.indexOf(region.id);
    if (index != -1) {
      return "active";
    } else {
      return "";
    }
  }

  uploadDocument(files) {
    this.newNews.file = <File>files.item(0);
  }

  getDate(date: string) {
    let day = moment(date).format('DD');
    let parseMonth = moment(date).format('MM');
    let year = moment(date).format('YYYY');
    let month = this.event.getMonthName(parseInt(parseMonth), true);
    return day + ' ' + month + ' ' + year + 'г.';
  }

  getDownload(fileID: number) {
    return ( environment.apiUrl+"/News/DownloadFile?FileID=" + fileID + "&SourceType=0" );
  }

  selectedNew: SingleNews;
  selectedId: number = -1;

  testArticle: SingleNews[] = [];
  countIsChecked: number = 0;
  sum: number;
  getCountNews() {
    this.countIsChecked = 0;
    for (let i = 0; i < this.articles.length; i++) {
      if (this.articles[i].isChecked == 0) {
        this.countIsChecked = this.countIsChecked + 1;
      }
    }

    this.event.count.emit(this.countIsChecked);
  }

  openNew(i, newsId) {
    this.server.setCheckNews(newsId).then(res => {
      this.server.getNews(this.user.region[0].id).then(res => {
        this.articles = this.updateArticles(res);
        this.getCountNews();
        if (this.selectedId == i) {
          this.articles[i].isOpen = false;
          this.selectedId = -1;
        } else {
          this.articles[i].isOpen = true;
          if (this.articles[this.selectedId])
            this.articles[this.selectedId].isOpen = false;
          this.selectedId = i;
        }
      });
    });
    this.selectedNew = this.articles[i];
  }

}
